// src/components/layout/SuperLayout.jsx
import React, { useState } from "react";
import SuperSidebar from "./SuperSidebar";
import SuperHeader from "./SuperHeader";

const SuperLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="w-screen h-screen overflow-hidden bg-[#f5f5f0]">
      {/* HEADER – full width */}
      <SuperHeader onMenuToggle={() => setSidebarOpen(true)} />

      {/* BODY */}
      <div className="flex w-full h-[calc(100vh-72px)]">
        {/* SIDEBAR */}
        <SuperSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        {/* CONTENT */}
        <main className="flex-1 w-full overflow-y-auto bg-[#f5f5f0] p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default SuperLayout;
